// extracted by mini-css-extract-plugin
export default {"CardVisual":"CardVisual_CardVisual__Y8BLg"};